export enum progressStatusCssClasses {
  'completed' = 'text-success',
  'major issue' = 'text-warning',
  'minor issue' = 'text-warning',
  'on track' = 'text-success',
  'planned' = 'text-success',
}
